import axios from "axios";
import store from './../store';
const appAxiosInstance = axios.create({
  baseURL: "https://permalink.name/api",
  headers: {
    'Content-Type': 'application/json',
    }
});
appAxiosInstance.interceptors.request.use((config) => {
  const token = store.getters['user/getToken'];
  config.headers.Authorization = `Bearer ${token}`;
  return config;
})
export default appAxiosInstance;